import angular from "angular";
import tpl from "./viewApt.html";

/**
 * The view page for an apartment
 * the same layout as django view_apt.html
 *
 * Usage:
 *
 *   <div view-apt apt="apt"></div>
 *
 */
/* @ngInject */
export function viewApt(AptService, _) {
  return {
    scope: {
      apt: "="
    },
    replace: true,
    templateUrl: tpl,
    link: function($scope) {
      if (_.isObject($scope.apt)) {
        angular.extend($scope, $scope.apt);
        $scope.ready = true;
      } else {
        // This is for fetching and displaying by apt.id,
        // but nothing is using that right now.
        if (!_.isNumber($scope.apt)) {
          throw new Error("Invalid apt id " + $scope.apt);
        }
        AptService.get($scope.apt).then(
          function(apt) {
            $scope.apt = apt;
            angular.extend($scope, apt);
            $scope.ready = true;
          },
          function(err) {
            throw err;
          }
        );
      }
    }
  };
}
